import React from 'react';

import { json, jsonParseLinter } from '@codemirror/lang-json';
import { linter } from '@codemirror/lint';
import CodeMirror from '@uiw/react-codemirror';

const linterExtension = linter(jsonParseLinter());

export const JSONEditor = ({ value, onChange, defaultValue, disabled, height = '200px' }) => {
  // Only prettify on initial mount
  const [prettifiedValue, _setPrettifiedValue] = React.useState(() => {
    try {
      if (typeof value === 'string') {
        return JSON.stringify(JSON.parse(value), null, 2);
      }
      return JSON.stringify(value, null, 2);
    } catch (_e) {
      return value || '';
    }
  });

  // Do not update prettifiedValue after mount, even if value changes

  return (
    <CodeMirror
      value={prettifiedValue || defaultValue || ''}
      height={height}
      extensions={[json(), linterExtension]}
      onChange={onChange}
      theme="light"
      basicSetup={{
        lineNumbers: true,
        highlightActiveLine: true,
        highlightSelectionMatches: true,
        autocompletion: true,
        syntaxHighlighting: true,
        history: true,
      }}
      readOnly={disabled}
      style={{
        backgroundColor: disabled ? '#f0f0f0' : 'white',
      }}
    />
  );
};
